<template>
    <div class="input-group m-b-0" id="balancecheck">
        <form action="#" id="balancecheck-form">
            <input type="text"
                   class="m-b-30"
                   name="code"
                   placeholder="JW96 – S75S - 9FV8 – L9S4"
                   :maxlength="25"
                   v-model="searchField">
            <button class="button" type="submit" v-on:click.prevent="submit">Check</button>
        </form>

        <template v-if="hasSearched">
            <div class="result" id="not-found" v-if="resultNotFound">
                <div class="small">Niets gevonden</div>
                <h3>
                    Verkeerde code?
                </h3>
            </div>

            <div class="result" id="found-empty" v-else-if="result.data.balance === 0">
                <div class="small">Kaart gevonden</div>
                <h3>
                    Maar geen waarde.
                </h3>
            </div>

            <div class="result" id="found" v-else>
                <div class="small">Huidige waarde</div>

                <h3 v-if="result.data.has_full_balance === true && result.data.package !== null">
                    {{ result.data.package }}
                </h3>

                <h3 v-else>
                    {{ result.data.balance | nicePriceString }}
                </h3>

                <small v-if="result.data.expires_at" class="color--white">{{ $t('general.expiresAt') }} {{ result.data.expires_at | niceDateString }}</small>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        name: 'BalanceCheck',
        data () {
            return {
                searchField: '',
                searchFieldUnformatted: '',
                result: null,
                resultNotFound: false,
                hasSearched: false,
            }
        },

        watch: {
            searchField (code) {
                this.searchFieldUnformatted = code.split(' - ').join('').replace(/[^a-zA-Z0-9]+/g, "")
                this.searchField = this.searchFieldUnformatted.length >= 1 ? this.searchFieldUnformatted.match(new RegExp('.{1,4}', 'g')).join(' - ').toUpperCase() : ''
            }
        },

        methods: {
            submit () {
                if (this.searchField.length === 25) {
                    this.resultNotFound = false

                    axios.get('https://api.gifty.nl/v1/balance/' + this.searchFieldUnformatted.toLowerCase()).then(response => {
                        this.result = response.data
                    }).catch(() => {
                        this.resultNotFound = true
                    }).finally(() => {
                        this.hasSearched = true
                    })
                }
            }
        },

        filters: {
            nicePriceString (value) {
                let euros      = value / 100
                return `€ ${euros.toFixed(2).replace('.', ',')}`
            },
            niceDateString (value) {
                let date = new Date(value);

                // Format to DD - MM - yyyy
                return `${date.getDate()} - ${date.getMonth() + 1} - ${date.getFullYear()}`
            }
        },
    }
</script>
